import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth-context";
import { AppShell } from "./components/AppShell";
import { SignIn } from "./pages/auth/SignIn";
import { MagicLink } from "./pages/auth/MagicLink";
import { SignUp } from "./pages/auth/SignUp";
import { OnboardingCraft } from "./pages/auth/OnboardingCraft";
import { OnboardingShelf } from "./pages/auth/OnboardingShelf";
import { OnboardingSafety } from "./pages/auth/OnboardingSafety";
import { Welcome } from "./pages/auth/Welcome";
import { Dashboard } from "./pages/Dashboard";
import { RecipeIndex } from "./pages/RecipeIndex";
import { RecipeDetail } from "./pages/RecipeDetail";
import { RecipeBuilder } from "./pages/RecipeBuilder";
import { BatchLog } from "./pages/BatchLog";
import { Pantry } from "./pages/Pantry";
import { Settings } from "./pages/Settings";

const ONBOARDING_ROUTE: Record<string, string> = {
  craft: "/onboarding/craft",
  shelf: "/onboarding/shelf",
  safety: "/onboarding/safety",
};

export default function App() {
  const { account, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", fontFamily: "var(--font-heading)" }}>
        ALEMBIC
      </div>
    );
  }

  if (!account) {
    return (
      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/magic-link" element={<MagicLink />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="*" element={<Navigate to="/sign-in" replace />} />
      </Routes>
    );
  }

  if (account.onboarding_step !== "done") {
    const target = ONBOARDING_ROUTE[account.onboarding_step] ?? "/onboarding/craft";
    return (
      <Routes>
        <Route path="/onboarding/craft" element={<OnboardingCraft />} />
        <Route path="/onboarding/shelf" element={<OnboardingShelf />} />
        <Route path="/onboarding/safety" element={<OnboardingSafety />} />
        <Route path="*" element={<Navigate to={target} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/welcome" element={<Welcome />} />
      <Route
        path="*"
        element={
          <AppShell>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/recipes" element={<RecipeIndex />} />
              <Route path="/recipes/new" element={<RecipeBuilder />} />
              <Route path="/recipes/:id" element={<RecipeDetail />} />
              <Route path="/recipes/:id/edit" element={<RecipeBuilder />} />
              <Route path="/batches" element={<BatchLog />} />
              <Route path="/pantry" element={<Pantry />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AppShell>
        }
      />
    </Routes>
  );
}
